import React from "react"
import { Flex } from ".."
import { scale, breakpoint } from "../../styles"
import { ColorKeys } from "../../styles/constants/colors"
import styled from "styled-components"

export interface InfoTileProps {
	backgroundColor: ColorKeys
	description: string
	value: number
	icon: string
}

const InfoTileBox = styled.div`
	position: relative;
	width: 100%;

	&::before {
		content: "";
		display: block;
		padding-top: 100%;
	}

	& > div {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
	}
`

const TileIcon = styled.img`
	width: 10.2vw;
	height: 10.2vw;
	margin-top: ${scale.px(1.25)};

	${breakpoint("m")`
		width: 5vw;
		height: 5vw;	
	`}

	${breakpoint("xl")`
		width: ${scale.px(8)};
		height: ${scale.px(8)};
	`}
`

const ResponsiveTextValue = styled.h2`
	font-size: 8vw;
	text-align: center;
	margin-bottom: 8px;
	margin-top: 8px;
	font-weight: bold;

	${breakpoint("m")`
		font-size: 4vw;
	`}
	${breakpoint("xl")`
		font-size: ${scale.px(6)};
	`}
`

const ResponsiveTextDescription = styled.h3`
	font-size: 3vw;
	text-align: center;
	margin-bottom: 8px;
	font-weight: bold;
	white-space: pre-line;
	max-width: 25vw;

	${breakpoint("m")`
		font-size: 1.6vw;
		line-height: 2vw;
		max-width: 15vw;
		`}
	${breakpoint("xl")`
		font-size: ${scale.px(2.5)};
		line-height: ${scale.px(3)};
		max-width: ${scale.px(22)};
	`}
`

const InfoTile: React.FC<InfoTileProps> = (props) => {
	return (
		<InfoTileBox>
			<Flex
				justifyContent="center"
				alignItems="center"
				flexDirection="column"
				backgroundColor={props.backgroundColor}
				width="100%"
				h={1}
			>
				<TileIcon src={props.icon} alt="" />
				<Flex px={1}>
					<ResponsiveTextValue>{props.value}</ResponsiveTextValue>
				</Flex>
				<Flex px={1}>
					<ResponsiveTextDescription>
						{props.description}
					</ResponsiveTextDescription>
				</Flex>
			</Flex>
		</InfoTileBox>
	)
}

export { InfoTile }
